import { Providers, Enums } from '@flightscope/baseball-stats';

export default function pitchResultCombinedNameMapper(cat) {
  return Providers.EnumValueProvider.getValue(cat, Enums.PitchResultCombined, Enums.PitchResultCombined.Unidentified.key, null, 'name');
}
